import React from 'react';
import { formatStringAsCurrency, formatStringAsPercent } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function SiteNeutralPayment(props) {

    return (<>
        <h4>Site Neutral Payment</h4>
        <ResultValue label="Site Neutral Rate" value={formatStringAsCurrency(props.result.siteNeutralPayment)} />
        <ResultValue label="Outlier - Site Neutral" value={formatStringAsCurrency(props.result.siteNeutralOutlier)} />
        <ResultValue label="Site Neutral Blend Percentage" value={formatStringAsPercent(props.result.siteNeutralBlendPct)} />
    </>);
}